app.directive("sticky",function(){
   
    return {
      
      restrict:"E",  
      transclude: true,
      templateUrl:"/assets/js/angular/components/directives/sticky/sticky.html",
      scope:{
          
          checkboxes:"=" //collection with checked boolean parameter
      },
      controller:["$scope",function stickyController($scope){
        
        
        $scope.hasCheckboxes=function(){
            
          
            return $scope.checkboxes.filter(function(el){ return el.checked }).length>0;
            
        };
        
        
        $scope.$watch("hasCheckboxes");
          
          
      }]
        
    };
    
});


